const __WEBPACK_NAMESPACE_OBJECT__ = auth0;